import React, { useEffect } from 'react'
import { isLoginPage } from '../../utils/location'
import { getUserLocalStorage } from '../AuthProvider/utils'
import {useNavigate, useParams} from 'react-router-dom'
import { useAuth } from '../AuthProvider/useAuth'
import { getAccessTypeByRoute } from '../../utils/routesByType'

function index() {

  const navigate = useNavigate()
  const { validadeAccess } = useAuth()

  async function validateAccessOnRoute() {
    const accessType = getAccessTypeByRoute(window.location.pathname)
    if(accessType) await validadeAccess(accessType)
  }

  useEffect(() => {
    const user = getUserLocalStorage()
    validateAccessOnRoute()
    if (!isLoginPage() && !user) {
      return navigate('/')
    }

    if (isLoginPage() && user) {
      return navigate('/welcome')
    }
    
  }, [window.location.pathname])

  return (
      <></>
  )
}

export default index